import { useQuery } from '@tanstack/react-query';
import { fetchPublicSectionEvents } from '../api/events.public.api';
import { publicEventsKeys } from './events.keys';

/**
 * The curated public events section for Home and Benefits, already capped and
 * ordered by the backend. An empty array is a valid, successful result.
 */
export function usePublicEvents() {
  return useQuery({
    queryKey: publicEventsKeys.section(),
    queryFn: fetchPublicSectionEvents,
  });
}
